import React, { useState, useCallback } from 'react'
import clear from '../../../assets/icons/clear.svg'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import Alert from '../../../components/subComponents/Notifications/Alert'
import { replantplantingStewardship, patchStewardshipHistoryData } from '../../../services/apiHelper'

const ReplantView = ({ showReplant, setShowReplant, plantingData, stewardship_activity_id,getStewardshipFieldsCall, replantOrLost, fieldCompleteOrNot, contract_id, userInfo }) => {
  const [checkedData, setCheckedData] = useState()
  const [showNextDetails, setShowNextDetails] = useState(false)
  const [plantingDate, setPlantingDate] = useState(new Date().toISOString().substr(0, 10))
  const [plantingNotes, setPlantingNotes] = useState('')
  const [acresValue, setAcresValue] = useState(0)
  const [acresError, setAcresError] = useState(false)
  const [acresErrorText, setAcresErrorText] = useState('')
  const [showAlert, setShowAlert] = useState(false)
  const [confirmStatus,setConfirmStatus] = useState(false)

  const patchStewardshipHistoryCall = useCallback(() => {
    const userInfoForStewardship = { ...userInfo, action:'Replant', system_name: 'GrowMore360' }
    patchStewardshipHistoryData(contract_id, userInfoForStewardship)
  }, [
    contract_id, userInfo
  ])

  const checkedPlantingdata = id => {
    const findIsDisable = fieldCompleteOrNot.findIndex(data => data.id === id && data.isDisable === true)
    if(findIsDisable === -1) {
      const obj = plantingData.find(data => data.id === id)
      setShowAlert(false)
      setCheckedData(obj)
      setAcresValue(obj.total_planted_acres)
    } else {
      setShowAlert(true)
      setCheckedData()
      setAcresValue()
      document.getElementById(id).checked = false
    }
  }

  const hideReplantFunc = () => {
    if (checkedData) {
      document.getElementById(checkedData.id).checked = false
      setCheckedData()
      setPlantingNotes('')
      setPlantingDate(new Date().toISOString().substr(0, 10))
    }
    setShowNextDetails(false)
    setShowReplant(false)
    setAcresErrorText('')
    setAcresError(false)
  }

  const showNextDetailsFunc = () => {
    setShowNextDetails(prev => !prev)
    setShowReplant(false)
  }


  const saveReplantData = () => {
    if(Number(acresValue) > checkedData?.total_planted_acres){
      setAcresErrorText('The replanted acres cannot be more than the contract acres.')
      setAcresError(true)
      return
    }
    if(Number(acresValue) === 0){
      setAcresErrorText('Please enter correct acres value')
      setAcresError(true)
      return
    }
    setAcresErrorText('')
    setAcresError(false)
    document.getElementById(checkedData.id).checked = false
    setCheckedData()
    setPlantingNotes('')
    setPlantingDate(new Date().toISOString().substr(0, 10))
    const params = {
      stewardship_id: stewardship_activity_id,
      field_id: checkedData.id,
      replanted_date: plantingDate,
      acres_replanted: checkedData.total_planted_acres.toString(),
      notes: plantingNotes
    }
    setConfirmStatus('LOADING')
    replantplantingStewardship(params).then(res => {
      if (res.status === 200) {
        getStewardshipFieldsCall()
        patchStewardshipHistoryCall()
        setTimeout(()=> {
          setConfirmStatus()
          setShowNextDetails(false)
        },2000)
      }
    })
  }

  const acresKeyPress = evt => {
    if (evt.which < 46 || evt.which > 57 || evt.which === 47) {
      evt.preventDefault()
      return
    }
    setAcresError(false)
  }

  const changeAcresValue = e => {
    setAcresError(false)
    setAcresValue(e.target.value)
  }

  return (
    <>
      <div className="modalContainer" style={{ display: showReplant ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100">
          <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
            <div className='df jcsb'>
              <p className='fz16 m5 fw600 tal'>Stewardship: Replant</p>
              <button className='bdnone mr5 bgc-t' onClick={hideReplantFunc}>
                <img src={clear} alt='cancel button' />
              </button>
            </div>
            <div className='bdnone bt1-s-lightgray' />
            <p className='fz16 m5 fw600 tal'>Select field for replant</p>
            <div className="df">
              <div className="mr25 w33.3333% pl10 ml5">
                <div className="bd1-s-lightgray pb15 pl5 bdrs-4 pr5 tal">
                  {
                    plantingData?.map((data, id) =>                                    
                      !replantOrLost?.[id]?.fieldLost ?
                        <div key={id} className="w150 mau mt10 tal">
                          <input className="dib w20" type="radio" id={data.id} name="plantingData" value={data.name} onClick={() => {
                            checkedPlantingdata(data.id)
                          }} />
                          <label htmlFor={data.id}>{data.name}</label>
                        </div> : ''                                     
                    )
                  }
                </div>
              </div>
              <div className="w66.6666% pr10 mr5">
                <div className="table">
                  <div className="tableHeader pl16">
                    <div className="Name cell">
                      <div>Name</div>
                    </div>
                    <div className="Acres cell">
                      <div>Acres</div>
                    </div>
                  </div>
                  {
                    checkedData ?
                      <div role="row" className="pl16 df h48 ov dp aic">
                        <div className="name cell">{checkedData.name}</div>
                        <div className="total_planted_acres cell">{checkedData.total_planted_acres}</div>
                      </div>
                      : <p className="fz15">Select a field from the list on the left.</p>
                  }
                </div>
              </div>
            </div>
            <div className='mt20 mb16 bdnone bt1-s-lightgray' />
            <div className='df jcfe posr'>
              <Button type='default' text='Cancel' onClick={hideReplantFunc} />
              <Button type='success' text='Next: Field replant details' customClassName='mr15 ml10' onClick={showNextDetailsFunc} disabled={checkedData ? false : true}/>
            </div>
          </div>
        </div>
      </div>

      {showAlert ? (
        <Alert
          alertMessage='Please make sure to enter stewardship planting information first.'
          handleDismiss={() => setShowAlert(false)}
        />
      ) : null}

      <div className="modalContainer" style={{ display: showNextDetails ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100">
          <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
            <div className='df jcsb'>
              <p className='fz16 m5 fw600 tal'>Stewardship: Replant</p>
              <button className='bdnone mr5 bgc-t' onClick={hideReplantFunc}>
                <img src={clear} alt='cancel button' />
              </button>
            </div>
            {confirmStatus === 'LOADING' ?
              <TableStatus status='LOADING'></TableStatus>
              :
              <>
                <div className='bdnone bt1-s-lightgray' />
                <p className='fz16 m5 mb15 fw600 tal'>Field replant details: {checkedData?.name}</p>
                <p className="bdrs-4 p10 fz15 mau mt10 mb10 ml15 mr15" style={{ border: '1px solid red', backgroundColor: '#e9cbcb', display: acresError ? 'block' : 'none' }}>{acresErrorText}</p>
                <div className="df fz15">
                  <div className="flx1 mr10">
                    <p className="m0 p0 pl15 tal">Date of field replant</p>
                    <input
                      role='grid'
                      aria-label='plantedDate'
                      className='bdrs-4 bd1-s-lightgray ml15 mt5 tal p9'
                      key='plant_date'
                      type='date'
                      value={plantingDate}
                      onChange={e => {
                        setPlantingDate(e.target.value)
                      }}
                    />
                  </div>
                  <div className="flx1">
                    <p className="m0 p0 pl15 tal">Acres replant</p>
                    <input type="number" className="w90% bdrs-4 bd1-s-lightgray ml15 mr15 mt5 tal" value={acresValue} onKeyPress={acresKeyPress} onChange={changeAcresValue}/>
                  </div>
                </div>
                <div className="fz15">
                  <p className="m0 pl15 tal">Notes (optional)</p>
                  <div className="ml15 mr15"><textarea rows="3" cols="70" className="w100%" value={plantingNotes} onChange={e => {
                    setPlantingNotes(e.target.value)
                  }} /></div>
                </div>
                <div className='mt20 mb16 bdnone bt1-s-lightgray' />
                <div className='df jcfe posr'>
                  <Button type='default' text='Back' onClick={hideReplantFunc} />
                  <Button type='success' text='Save' customClassName='mr15 ml10' onClick={saveReplantData} />
                </div>
              </>
            }
          </div>
        </div>
      </div>

    </>
  )
}



export default ReplantView
